module.exports = __webpack_public_path__ + "static/media/download.5459ba1f.svg";